import { pick } from 'lodash-es';

import { FILTER_RULE_ENUMS, FILTER_OPERATOR_ENUMS } from '@constants';

export const FOR_SALE_PAGE_SIZE = 200;

export const getForSaleQueryParams = (payload = {}) => {
  if (!payload?.pageSize) {
    payload.pageSize = FOR_SALE_PAGE_SIZE;
  }
  if (!payload?.page) {
    payload.page = 1;
  }

  return pick(payload, ['page', 'pageSize', 'order', 'orderBy', 'query']);
};

export const getForSaleRequestPayload = (enums = {}) => {
  const reservationsTypes = enums?.reservationsTypes?.reduce(
    (acc, reservation) => {
      Object.assign(acc, { [reservation.text]: reservation.value });
      return acc;
    },
    {}
  );

  const forSaleValue = reservationsTypes?.['For Sale'];

  if (forSaleValue === undefined) {
    return { type: FILTER_RULE_ENUMS.EmptyRuleType };
  }

  return {
    type: FILTER_RULE_ENUMS.AndRuleType,
    field: null,
    operator: null,
    value: [
      {
        field: 'availability.reservationType',
        operator: FILTER_OPERATOR_ENUMS['='],
        type: FILTER_RULE_ENUMS.IsAnyOfRuleType,
        value: [forSaleValue],
      },
    ],
  };
};
